import * as React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import type { InjectedRouter } from 'js/lib/connectToRouter';

import { color } from '@coursera/coursera-ui';
import { SvgCheckSolid } from '@coursera/coursera-ui/svg';

import Markdown from 'bundles/cms/components/Markdown';
import { clearActionQueryParam, getActionQueryParam } from 'bundles/expression-of-interest/utils/util';
import { ENROLLMENT_STATUSES } from 'bundles/premium-certificate/constants/constants';
import type { EnrollmentChecklistProps } from 'bundles/premium-certificate/constants/types';

import 'css!bundles/premium-certificate/__styles__/EnrollmentChecklist';
import 'css!bundles/premium-certificate/__styles__/university-program-index';

const checkmarkIconSize = 14;

const renderChecklistItem = ({ item, enrollmentChecklistItemStatuses, helpText }: $TSFixMe) => {
  const shouldShowRegHelp: boolean = item.id === ENROLLMENT_STATUSES.SUBMIT_APPLICATION;
  const isItemChecked = enrollmentChecklistItemStatuses.includes(item.id);
  const checkMarkColor = isItemChecked ? color.primary : color.disabled;
  const markdownClassName = classnames('checklist-item-markdown', { 'checklist-item-checked': isItemChecked });
  return (
    <li data-testid="enrollment-checklist-item" key={item.id}>
      <div className="checklist-item-content">
        <div className="checkbox-container">
          <SvgCheckSolid size={checkmarkIconSize} color={checkMarkColor} />
        </div>
        <Markdown className={markdownClassName} source={item.text} />
      </div>
      <div>
        {shouldShowRegHelp && (
          <div className="checklist-item-subtitle" data-testid="enrollment-checklist-reghelp">
            {helpText}
          </div>
        )}
      </div>
    </li>
  );
};

class EnrollmentChecklist extends React.Component<EnrollmentChecklistProps> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: {
    router: InjectedRouter;
  };

  removeActionQueryParam = () => {
    // Needed to clear global variable if user is already enrolled in the checklist
    const { router } = this.context;
    const actionQueryParam = getActionQueryParam(router.location);
    if (!actionQueryParam) {
      return;
    }

    clearActionQueryParam(router);
  };

  componentDidMount() {
    this.removeActionQueryParam();
  }

  render() {
    const {
      enrollmentChecklistHeading,
      enrollmentChecklistItems,
      enrollmentChecklistItemStatuses = [],
      helpText,
    } = this.props;

    if (!enrollmentChecklistItems) return null;

    return (
      <div className="rc-EnrollmentChecklist">
        <div id="enrollChecklistHeader" aria-live="polite">
          <Markdown source={enrollmentChecklistHeading} />
        </div>
        <ul>
          {enrollmentChecklistItems.map((item) =>
            renderChecklistItem({ item, enrollmentChecklistItemStatuses, helpText })
          )}
        </ul>
      </div>
    );
  }
}

export default EnrollmentChecklist;
